import { Popover as HeadlessPopover } from "@headlessui/react"

import PopoverSelectButton from "./PopoverSelectButton"
import PopoverSelectCombobox from "./PopoverSelectCombobox"
import { PopoverSelectProps } from "./types"
import { PopoverPanel } from "../../../base/overlay/Popover"
import { PopoverComboboxItem } from "../types"

function PopoverSelect<T extends PopoverComboboxItem = PopoverComboboxItem>({
  items,
  selected,
  onSelect,
  onChangeQuery,
  label,
  placeholder,
  disabled,
  invalid,
  errorMessage,
  className,
  buttonClassName,
  buttonSize = "large",
  buttonAriaLabel,
  buttonTitleOverride,
  hideChevron,
  maxLength,
}: PopoverSelectProps<T>) {
  return (
    <HeadlessPopover className={className}>
      <PopoverSelectButton
        accessory={selected?.accessory}
        content={selected?.content}
        label={label}
        title={buttonTitleOverride ?? selected?.label}
        placeholder={placeholder}
        disabled={disabled}
        invalid={invalid}
        errorMessage={errorMessage}
        size={buttonSize}
        className={buttonClassName}
        aria-label={buttonAriaLabel}
        hideChevron={hideChevron}
      />
      <PopoverPanel>
        <PopoverSelectCombobox<T>
          items={items}
          selected={selected}
          onSelect={onSelect}
          onChangeQuery={onChangeQuery}
          maxLength={maxLength}
        />
      </PopoverPanel>
    </HeadlessPopover>
  )
}

export default PopoverSelect
